import Swiper from 'swiper/bundle';

class UTSpotItems {
  constructor() {
    this.wrapper = document.querySelector("[data-role='ut-spot-items']");

    if (!this.wrapper) return;

    this.swiperElm = this.wrapper.querySelector("[data-role='ut-spots-swiper']");
    this.swiperNext = this.wrapper.querySelector("[data-role='ut-spots-swiper-next']");
    this.swiperPrev = this.wrapper.querySelector("[data-role='ut-spots-swiper-prev']");

    if (!this.swiperElm || !this.swiperNext || !this.swiperPrev) return;

    this.swiper = new Swiper(this.swiperElm, {
      slidesPerView: 1.5,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
    });
  }
}

export default UTSpotItems;
